import { axiosApi } from "../../../../../../../api/dbAxios";

export const fetchTeamComments = async (
  regulatorCode: string | undefined,
  case_no: string | undefined,
) => {
  const test_email = "ykozak@deloittece.com";
  try {
    const isLocalhost =
      typeof window !== "undefined" && window.location.hostname === "localhost";

    const response = await axiosApi.get(
      `/items/${regulatorCode}/${case_no}/comments/`,
      {
        params: isLocalhost ? { test_email } : {},
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Team Comments", error);
    return {};
  }
};
